import React from "react";
import { ArrowRight, ArrowUpRight } from "lucide-react";
import { insights } from "../mock";

import { tr } from "../i18n";
export default function Insights() {
  const [featured, ...rest] = insights;

  return (
    <section id="insights" className="bg-white py-20 md:py-28 scroll-mt-20">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="flex items-end justify-between mb-12 reveal">
          <div>
            <div className="deco-line w-24 mb-6" />
            <h2 className="font-display text-[34px] md:text-[46px] text-[#0b1f3a]">
              {tr("Insights from R&H")}
            </h2>
          </div>
          <button className="hidden md:inline-flex items-center gap-2 text-[14px] font-medium text-[#0b1f3a] hover:text-[#c2a15a] transition-colors uppercase tracking-wide">
            {tr("Read more")} <ArrowRight size={16} />
          </button>
        </div>

        <div className="grid lg:grid-cols-2 gap-6">
          {/* Featured */}
          <article className="reveal group cursor-pointer rounded-2xl overflow-hidden ring-1 ring-[#0b1f3a]/8 bg-[#f6f2e9]/30">
            <div className="overflow-hidden">
              <img
                src={featured.image}
                alt={featured.title}
                className="w-full h-[300px] md:h-[340px] object-cover transition-transform duration-500 group-hover:scale-105"
              />
            </div>
            <div className="p-7">
              <span className="text-[12px] uppercase tracking-widest text-[#c2a15a] font-medium">
                {featured.tag}
              </span>
              <h3 className="font-display text-[24px] text-[#0b1f3a] mt-2 leading-snug group-hover:text-[#163561] transition-colors">
                {featured.title}
              </h3>
              <p className="text-[#0b1f3a]/60 text-[15px] mt-3 leading-relaxed">
                {featured.excerpt}
              </p>
              <p className="text-[#0b1f3a]/40 text-[13px] mt-4">
                {featured.date}
              </p>
            </div>
          </article>

          {/* Rest */}
          <div className="grid gap-5">
            {rest.map((post, i) => (
              <article
                key={i}
                className="reveal group cursor-pointer flex gap-5 rounded-2xl overflow-hidden ring-1 ring-[#0b1f3a]/8 bg-[#f6f2e9]/30 p-4"
                style={{ transitionDelay: `${i * 70}ms` }}
              >
                <div className="w-28 sm:w-36 shrink-0 overflow-hidden rounded-xl">
                  <img
                    src={post.image}
                    alt={post.title}
                    className="w-full h-full object-cover min-h-[110px] transition-transform duration-500 group-hover:scale-105"
                  />
                </div>
                <div className="flex flex-col justify-center pr-2">
                  <span className="text-[11px] uppercase tracking-widest text-[#c2a15a] font-medium">
                    {post.tag}
                  </span>
                  <h3 className="font-display text-[17px] md:text-[19px] text-[#0b1f3a] mt-1 leading-snug flex items-start gap-1">
                    {post.title}
                    <ArrowUpRight
                      size={16}
                      className="shrink-0 mt-1 opacity-0 -translate-x-1 group-hover:opacity-100 group-hover:translate-x-0 transition-all text-[#c2a15a]"
                    />
                  </h3>
                  <p className="text-[#0b1f3a]/40 text-[12px] mt-2">
                    {post.date}
                  </p>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
